import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './KWitt_Main.html?raw';
import on from 'dojo/on';
import MainProperties from '../../WebCalendar_TS/MainProperties/MainProperties';
import KWittBookingDetails from '../KWitt_WebCalendar/KWittBookingDetails/KWittBookingDetails';
import "../KWitt_WebCalendar/KWittBookingDetails/KWittBookingDetails";
import "../../WebCalendar_TS/MainProperties/MainProperties";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import { ToasterHelpers } from "../../../more/Helpers";
import { WebcalendarTypes } from "../../../moreCore/UI/moreCoreCalendar/WebCalendarTypes";



class KWitt_Main extends compose(_WidgetBaseSP) {
    
    templateString: any = template;

    mainProperties: MdsLax<InstanceType<typeof MainProperties>>;

    kwittCalendarContent: HTMLDivElement;

    private _calendarCreated() {

        on(this.mainProperties.calendar, "viewtypeChange", lang.hitch(this, this._viewtypeChanged));

    }
    _viewtypeChanged(data: any) {
        // ES GEHT NED!!
        console.debug("_viewtypeChanged", data);
    }

    showBookingDetails(item: WebcalendarTypes.WebCalendarItemData_Default): void {

        let bookingDetails = new KWittBookingDetails();
        bookingDetails.itemId = item.id;
        bookingDetails.KWittCalendarMainWrapper = this;


        bookingDetails.startup();

        let dlg = new GenericDialog();
        dlg.setCloseOnEscape(true);
        dlg._setCloseBtnAttr(true);
        dlg._setTopCloseBtnAttr(true);

        //dlg._setCallbackAttr(lang.hitch(this, function () {
        //    this.removeUrlParameter(KWitt_WebCalendar_UrlParameters.action);
        //    this.removeUrlParameter(KWitt_WebCalendar_UrlParameters.item);
        //    this.removeUrlParameter(KWitt_WebCalendar_UrlParameters.dateEnd);
        //    this.removeUrlParameter(KWitt_WebCalendar_UrlParameters.dateStart);
        //    this.removeUrlParameter(KWitt_WebCalendar_UrlParameters.intervalSteps);
        //    this.removeUrlParameter(KWitt_WebCalendar_UrlParameters.intervalType);
        //}))

        dlg.addButton("downloadTravelList",
            this.translations["WebCalender_BtnLabel_TravelListReport"],
            lang.hitch(bookingDetails, bookingDetails._onClick_DownloadTravelList),
            this.translations["WebCalender_BtnTitle_TravelListReport"],
            "mds-button-base w3-padding round mds-hover-bright w3-hide w3-disabled accentBG",
            "fas fa-download",
            false,
            "last");

        bookingDetails.downloadTravelListBtnNode = dlg.getButtonByName("downloadTravelList").node;

        dlg._setHeaderAttr(item.columnview_head_text);

        dlg.addNodeToContent(bookingDetails.domNode);
        dlg.show();
    }

    private _setupMainPropertes(): void{

        if (this.mainProperties != null) {
            this.mainProperties.destroy();
            this.mainProperties = null;
        }

        this.mainProperties = new MainProperties();

        on(this.mainProperties, "calendarCreated", lang.hitch(this, this._calendarCreated));
        
        this.UiModder.domConstruct.place(this.mainProperties.domNode, this.domNode, "first");

        let detailFct = lang.hitch(this, this.showBookingDetails);

        this.mainProperties.setMainConfig({
            itemDetails: {
                customItemClickFunction: detailFct
                //requestUrl: 
            },
            userProperties: {
                customFunctionName: "Webtool_API_Webcalendar__GetUserProperties",
                requestUrl: "Calendar/GetUserProperties",
                //requestParams: [{ name: "jsonData", value: { user: "unknown" } }]
            },
            filterData: {
                customFunctionName: "Webtool_API_Webcalendar__GetFilterData"
            },
            defaultDisplaySettings: {
                b_show_end_time: true,
                //hideColumnHead: true
            }
        });
        
        this.mainProperties.startup();

        this._preparePanels();

        // Titel überschreiben, der vom Webkalender gesetzt würde
        this.mainProperties.setTitles(
            this.translations["KWittCalendar__MainTitle"],
            this.translations["KWittCalender__Title"]);

    }

    _onEditUserDlgResponse(dlg: MdsLax<InstanceType<typeof GenericDialog>>, response: number) {
        this.removeUrlParameter(KWitt_WebCalendar_UrlParameters.action);
    }

    editUserError(dlg: MdsLax<InstanceType<typeof GenericDialog>>, error: any): void {
        this.StandbyStop();

        dlg._setContentAttr(error.Message);

        if (this.mainProperties) {
            //this.mainProperties.publishToastMessage()
        }

        console.error(error);
    }

    private _preparePanels(): void {
        if (!this.mainProperties) {
            return;
        }

        let props = this.mainProperties;

    }

    publishToastMessage(text: string, icon: ToasterHelpers.ToasterIcons = ToasterHelpers.ToasterIcons.none, timeout?: number, extendedMessage?: string): void {
        if (!this.mainProperties) {
            alert(text);
            console.error(text, extendedMessage);
            return;
        }
        this.mainProperties.publishToastMessage(text, icon, timeout, extendedMessage)
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
        //this._isStartup = true;
        //this._continueWithSession();
        //this._checkUrlParameters();
        this._setupMainPropertes();
    }

}

export default mdsWidget(KWitt_Main);